var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{staticStyle:{"width":"200px","height":"200px"},attrs:{"src":_vm.$matrix.Config.ImageSite + _vm.value,"preview-src-list":[_vm.$matrix.Config.ImageSite + _vm.value]}})
}
var staticRenderFns = []

export { render, staticRenderFns }